import $ from "jquery";
import {trace} from "./../shared/helpers";


const StoartBgCarousel = {

  $container: null,
  $list: null,
  $img: null,
  current: false,
  images: [],
  imagesNum: 0,
  imagesLoaded: 0,
  imageItemSelector: '.image-home-bg',
  interval: false,
  timeout: false,
  timeout2: false,
  delay: 5000,
  animationTime: 2500,

  // get current image index
  getCurrentImageInd() {
    let src = this.$container.find('img.in').attr("src");
    return this.images.indexOf(src);
  },

  // next image
  nextImage() {
    let c = this.getCurrentImageInd();
    c++;
    if (c == this.imagesNum) {
      c = 0;
    }
    // trace("next image", c);
    let $img = this.getCurrentImage();
    this.showImage( this.images[c] );
    if ($img.length) {
      this.hideImage( $img );
    }
  },



  // set interval
  startInterval() {
    clearInterval(this.interval);
    setInterval(this.nextImage.bind(this), this.delay + this.animationTime);
  },

  // hide image
  hideImage( $img ) {    
    clearTimeout(this.timeout);
    $img.addClass('out');
    this.timeout = setTimeout(()=> {
      $img.removeClass('in');
      $img.removeClass('out');
    }, this.animationTime);

  },
  getCurrentImage() {
    return this.$container.find('img.in').eq(0);
  },
  // get free $img
  getFreeImg() {
    return this.$container.find('img:not(.in)').eq(0);
  },
  // show image
  showImage( src ) {    
    if (!src) {
      return false;
    }
    let $img = this.getFreeImg();
    $img.attr('src', src);
    clearTimeout(this.timeout2);
    this.timeout2 = setTimeout(()=> {
      $img.addClass("in");
    }, 50)
    
  },

  // loadImage
  loadImage( ind, callback = null ) {    
    let src = this.$list.eq(ind - 1).data("src");
    // trace("load image", ind, src);
    let img = new Image();
    $(img).on("load", ()=> {
      this.imagesLoaded++
      this.images.push(src);
      // trace("image loaded", src, this.imagesLoaded, "load next:", this.imagesLoaded < this.imagesNum);
      if ($.isFunction( callback )) {
        callback( src );
      }
      if (this.imagesLoaded < this.imagesNum) {
        this.loadImage( ind + 1 );
      } else if (this.imagesLoaded == this.imagesNum) {
        this.startInterval();
      }
    });
    $(img).on("error", ()=> {      
      // trace("error, image could not be loaded", src);
    });
    $(img).attr("src", src);
  },

  // build image
  buildImage() {

  },
  // ############
  // ### init ###
  init() {
    // trace("init stoart bg carousel");
    this.$container = $('.home-bg');
    if (this.$container.length) {
      if (this.$container.data("delay")) {
        this.delay = parseInt(this.$container.data("delay"));
      }      
      this.$list = this.$container.find(this.imageItemSelector);
      this.imagesNum = this.$list.length;
      if (this.imagesNum > 0) {
        this.buildImage();
        this.loadImage(1, this.showImage.bind(this));
      }
    }

  }
}


export default StoartBgCarousel;